import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { DonutChartCardData } from '../../../utils/pageContent';

const DonutChartCard = ({
  title,
  isTotal = true,
  data,
  className,
  chartClassName,
  hidePercentage = false,
  range = false,
  options,
  open,
  option,
  setOption,
  setOpen,
  labelClassName,
  optionClassName,
  circleClassName,
  totalAgeEngagements = 0
}) => {
  const dataD = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: DonutChartCardData.modalLabel,
        data: data.map((item) => item.value),
        backgroundColor: data.map((item) => item.color),
        hoverBackgroundColor: data.map((item) => item.color),
        borderWidth: 1,
        borderRadius: 10,
        borderJoinStyle: 'round'
      }
    ]
  };
  console.log(data);
  const optionsD = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      color: {
        enabled: true
      }
    },
    cutout: '90%',
    radius: '70%'
    // onResize: (chart) => {
    //   if (data.datasets[0].data.every(value => value === 0)) {
    //     chart.canvas.style.backgroundColor = '#f0f0f0'; // Set a default background color
    //   }
    // },
  };

  return (
    <div
      className={`md:p-6 p-4 w-full sm:mb-0 lg:w-1/5 min-w-full gap-2 sm:min-w-[202px] bg-[#FFFFFF] rounded-xl border border-[#E7E8EA] ${className} dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder flex flex-col justify-between`}
    >
      <div className="flex flex-row gap-2 px-1 justify-between items-start">
        <div className="w-full">
          <h2
            className={`${labelClassName} lg:text-[20px] text-[18px] w-[99%] tracking-tight leading-[22px] flex items-start font-medium text-[#0B0F18] text-left pl-[0px] md:pl-[0px] dark:text-shoorah-darkBg`}
          >
            {title}
          </h2>
        </div>
        {range && (
          <>
            <button onClick={() => setOpen(!open)} className="relative">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="dark:invert sm:w-[18px] sm:h-[16px]"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#0B1D2E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                  stroke="#0B1D2E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                  stroke="#0B1D2E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {open && (
                <ul
                  className={`w-[120px] h-fit overflow-y-auto rounded-xl z-10 bg-white border border-shoorah-borderGray ms-auto absolute right-0 py-2 ${
                    optionClassName ? optionClassName : 'top-5'
                  }`}
                >
                  {options?.length > 0 &&
                    options?.map((item, index) => (
                      <li
                        className={`pl-4 pr-6 py-2 hover:bg-shoorah-borderGray cursor-pointer text-left capitalize ${
                          option === index ? 'bg-shoorah-borderGray' : ''
                        }`}
                        onClick={() => {
                          setOpen(false);
                          setOption(index);
                        }}
                      >
                        {item?.label}
                      </li>
                    ))}
                </ul>
              )}
            </button>
          </>
        )}
      </div>
      <div className="relative flex max-h-[180px] justify-center items-center">
        {isTotal && (
          <div className="absolute text-center">
            <p className="text-sm text-[#606060] dark:text-shoorah-darkBg">
              {DonutChartCardData.total}
            </p>
            <p className="text-2xl text-[#0B0F18] dark:text-shoorah-darkBg">
              {totalAgeEngagements
                ? !isNaN(totalAgeEngagements)
                  ? totalAgeEngagements
                  : 0
                : !isNaN(data?.map((item) => item.value).reduce((a, b) => +a || 0 + +b || 0, 0))
                ? data?.map((item) => item.value).reduce((a, b) => +a || 0 + +b || 0, 0)
                : 0}
            </p>
          </div>
        )}
        {data?.map((item) => item.value).reduce((a, b) => +a || 0 + +b || 0, 0) === 0 && (
          <div
            className={`absolute text-center border-[4px] p-5 rounded-full ${
              circleClassName ? circleClassName : 'w-[120px] h-[120px]'
            }`}
            style={{ borderColor: data?.[data?.length - 1]?.color }}
          ></div>
        )}
        <Doughnut
          data={dataD}
          options={optionsD}
          style={{ width: '100%', height: '100%' }}
          className={chartClassName}
        />
      </div>
      <div className="flex flex-col md:flex-col lg:flex-col md:justify-between md:gap-5 lg:gap-3 gap-0">
        {data?.map((item, index) => (
          <div className="flex items-center justify-left" key={index}>
            <span
              className="w-3 h-3 rounded-full shrink-0 mr-2"
              style={{ backgroundColor: `${item.color}` }}
            ></span>
            <p className=" flex flex-row items-center gap-2 text-[16px] text-[#606060] dark:text-shoorah-gray1 whitespace-nowrap">
              {item.label}:{' '}
              <span className="text-[#0B0F18] lg:text-[20px] text-[18px] dark:text-shoorah-darkBg leading-tight truncate w-full">
                {!isNaN(item.percentage)
                  ? item.percentage === '100.00' ||
                    item.percentage === '100.0' ||
                    item.percentage === '100'
                    ? 100
                    : item.percentage
                  : 0}
                {!hidePercentage && '%'}
              </span>
            </p>
          </div>
        ))}
        {data?.length === 1 && <div className="lg:h-[25px] h-6"></div>}
      </div>
    </div>
  );
};

export default DonutChartCard;
